// extracted by mini-css-extract-plugin
export var Evergreen = "LogoSection-module--Evergreen--f018a";
export var Grey = "LogoSection-module--Grey--4414d";
export var White = "LogoSection-module--White--4ce71";
export var adjust = "LogoSection-module--adjust--4fd84";
export var centered = "LogoSection-module--centered--274a9";
export var competitivePage = "LogoSection-module--competitive-page--0c474";
export var darkBlue = "LogoSection-module--dark-blue--53e71";
export var logoCta = "LogoSection-module--logo-cta--379de";
export var logoGrid = "LogoSection-module--logo-grid--d68b2";
export var logos = "LogoSection-module--logos--68486";